var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',_vm._g(_vm._b({attrs:{"loading":_vm.isLoading,"items":_vm.items,"options":_vm.options,"server-items-length":_vm.total,"footer-props":{
        'items-per-page-options': [10, 20, 50, 100]
    }},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,s){return {key:s,fn:function(props){return [_vm._t(s,null,null,props)]}}})],null,true)},'v-data-table',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }